// 🔧 RequireValidEvent.js
// ✅ Purpose: Validate event-scoped routes before rendering the event app layout
// ✅ Features:
// - Uses shared EventContextProvider data
// - Prevents invalid event slugs from rendering event pages
// - Shows spinner only while the shared provider is resolving the event
// - Shows NotFound when the slug cannot resolve to an event
// - Avoids duplicate event Firestore reads
// - Fully commented for clarity

import React from "react";
import { useParams } from "react-router-dom";

import { useEventContext } from "../hooks/use_event_context";
import FullPageSpinner from "./FullPageSpinner";
import NotFound from "../pages/not_found";
import { logger } from "../utils/logger";

const RequireValidEvent = ({ children }) => {
  const { eventslug } = useParams();

  const {
    eventId,
    eventLoading,
    eventError,
  } = useEventContext({
    redirectIfNotFound: false,
  });

  // ✅ Defensive fallback. If this component is ever used outside
  // ✅ an event route, do not block rendering.
  if (!eventslug) {
    return <>{children}</>;
  }

  if (eventLoading) {
    return <FullPageSpinner message="Loading Event..." />;
  }

  if (!eventId || eventError) {
    logger.warn("Invalid event slug. Showing 404.", {
      eventslug,
      eventError,
    });

    return <NotFound />;
  }

  return <>{children}</>;
};

export default RequireValidEvent;
